<template>
  <div class="deferred-preview-page pa-4 pa-sm-6 grey lighten-4">
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12" md="9">
          <v-card class="deferred-doc pa-6" outlined>
            <section class="doc-section doc-header avoid-page-break">
              <div class="header-left">
                <v-img
                  :src="require('@/assets/logo-ma.png')"
                  alt="Mundo Albercas"
                  contain
                  max-height="70"
                  max-width="70"
                  class="mr-3"
                />

                <div>
                  <h1 class="doc-title mb-1">Mundo Albercas</h1>
                  <p class="doc-subtitle mb-0">
                    Sucursal Principal: {{ previewData.company.branchAddress }}
                  </p>
                  <p class="doc-subtitle mb-0">
                    Atención al Cliente: {{ previewData.company.phone }}
                  </p>
                  <p class="doc-subtitle mb-0">
                    Fecha de emisión: {{ previewData.issueDate }}
                  </p>
                </div>
              </div>

              <div class="header-right">
                <p class="pickup-label mb-1">VALE DE RECOLECCIÓN</p>
                <p class="folio-label mb-2">
                  FOLIO:
                  <span>{{ previewData.folio }}</span>
                </p>
                <v-chip small color="warning" outlined class="font-weight-bold mb-2">
                  {{ previewData.statusLabel }}
                </v-chip>
                <div class="qr-placeholder">
                  <v-icon large color="grey darken-2">mdi-qrcode</v-icon>
                  <span class="caption font-weight-medium">QR DE VALIDACIÓN</span>
                </div>
              </div>
            </section>

            <section class="doc-section warning-banner avoid-page-break">
              <v-icon color="warning darken-2" class="mr-2">mdi-alert</v-icon>
              <p class="mb-0">
                <strong>IMPORTANTE:</strong>
                {{ previewData.warningText }}
              </p>
            </section>

            <section class="doc-section owner-grid">
              <article class="owner-card avoid-page-break">
                <h2 class="owner-title">TITULAR DE LA COMPRA</h2>
                <div class="owner-line">
                  <span>Nombre:</span>
                  <strong>{{ previewData.customer.name }}</strong>
                </div>
                <div class="owner-line">
                  <span>ID Cliente:</span>
                  <strong>{{ previewData.customer.id }}</strong>
                </div>
              </article>

              <article class="owner-card avoid-page-break">
                <h2 class="owner-title">RESPONSABLE AUTORIZADO PARA RETIRO</h2>
                <div class="owner-line">
                  <span>Nombre:</span>
                  <strong>{{ previewData.authorizedPerson.name }}</strong>
                </div>
                <div class="owner-line">
                  <span>Contacto:</span>
                  <strong>{{ previewData.authorizedPerson.phone }}</strong>
                </div>
                <div class="owner-line">
                  <span>Email:</span>
                  <strong>{{ previewData.authorizedPerson.email }}</strong>
                </div>
                <div class="owner-line">
                  <span>Recoger:</span>
                  <strong>{{ previewData.authorizedPerson.pickupStore }}</strong>
                </div>
              </article>
            </section>

            <section class="doc-section product-table-section">
              <table class="product-table">
                <thead>
                  <tr>
                    <th>DESCRIPCIÓN DEL PRODUCTO</th>
                    <th>MARCA</th>
                    <th>MODELO</th>
                    <th>PIEZAS A RECOGER</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in previewData.products"
                    :key="`${item.sku}-${index}`"
                    class="avoid-page-break"
                  >
                    <td>
                      <p class="product-name mb-0">{{ item.name }}</p>
                      <p class="product-sku mb-0">SKU: {{ item.sku }}</p>
                    </td>
                    <td>{{ item.brand }}</td>
                    <td>{{ item.model }}</td>
                    <td class="text-center font-weight-black">{{ item.quantity }} pz</td>
                  </tr>
                </tbody>
              </table>
            </section>

            <section class="doc-section policy-text">
              <p class="mb-0">{{ previewData.policyText }}</p>
            </section>

            <section class="doc-section signatures">
              <div class="signature-block avoid-page-break">
                <div class="signature-line"></div>
                <p class="signature-title mb-0">Firma de Recibido del Cliente</p>
                <p class="signature-subtitle mb-0">Nombre y Fecha de Recepción</p>
              </div>

              <div class="signature-block avoid-page-break">
                <div class="signature-line"></div>
                <p class="signature-title mb-0">Sello de Tienda / Empleado</p>
                <p class="signature-subtitle mb-0">Autorización de Salida</p>
              </div>
            </section>
          </v-card>
        </v-col>

        <v-col cols="12" md="3" class="d-print-none">
          <v-card outlined class="pa-4">
            <h3 class="text-subtitle-1 font-weight-bold mb-3">Acciones</h3>

            <v-btn
              block
              color="primary"
              class="mb-3"
              @click="printDocument"
            >
              <v-icon left>mdi-printer</v-icon>
              Imprimir / PDF
            </v-btn>

            <v-btn
              block
              outlined
              color="secondary"
              class="mb-3"
              @click="goBack"
            >
              <v-icon left>mdi-arrow-left</v-icon>
              Volver
            </v-btn>

            <v-btn
              block
              text
              color="grey darken-1"
              @click="closeWindow"
            >
              Cerrar pestaña
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'DeferredDeliveryPreview',
  data() {
    return {
      previewData: {
        folio: '88745',
        issueDate: '20 de julio de 2026 a las 01:11 p.m.',
        statusLabel: 'PENDIENTE DE ENTREGA',
        company: {
          branchAddress: 'Av. Constitución 1234, Mty.',
          phone: '(81) 8000-0000',
        },
        warningText: 'Es indispensable presentar Identificación Oficial Vigente (INE / Pasaporte) de la persona autorizada al momento de presentarse a recoger la mercancía. Sin identificación, no se podrá realizar la entrega.',
        customer: {
          name: 'Juan Perez Lopez',
          id: '98234',
        },
        authorizedPerson: {
          name: 'Maria Rodriguez',
          phone: '81-8011-5552',
          email: 'maria@ejemplo.com',
          pickupStore: 'PRINCIPAL (Monterrey)',
        },
        products: [
          {
            name: 'PARA BAJAR PH 1KG - TRATAMIENTO DE CHOQUE',
            sku: 'QBPS-0001-BI',
            brand: 'BIOLIM',
            model: 'PH-MINUS',
            quantity: 2,
          },
          {
            name: 'BOMBA DE CALOR INTERHEAT SMART 90,000 BTU',
            sku: 'BMB-90K-INT',
            brand: 'INTER WATER',
            model: '8504022',
            quantity: 1,
          },
        ],
        policyText: 'La mercancia amparada en este comprobante ha sido pagada en su totalidad y se encuentra en proceso de traslado desde nuestro Almacen Central hacia la sucursal asignada. El cliente recibira una notificacion automatica por WhatsApp/Correo en cuanto su pedido este listo. A partir de dicha notificacion, cuenta con un plazo maximo de 30 dias naturales para su recoleccion. Transcurrido este periodo sin ser recolectada, la mercancia reingresara al inventario disponible y el importe pagado se convertira integramente en un Saldo a Favor para el cliente, sin cargos ni penalizaciones.',
      },
    };
  },
  created() {
    const routeFolio = this.$route.params.folio;
    if (routeFolio) {
      this.previewData.folio = routeFolio;
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    goBack() {
      this.$router.push('/deliveries');
    },
    closeWindow() {
      window.close();
    },
  },
};
</script>

<style>
.deferred-preview-page {
  min-height: 100vh;
}

.deferred-doc {
  background: #fff;
  border: 1px solid #d7dce3 !important;
}

.doc-section {
  margin-bottom: 16px;
  padding-left: 12px;
}

.doc-header {
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.header-left {
  align-items: flex-start;
  display: flex;
}

.header-right {
  border: 1px solid #d7dce3;
  border-radius: 8px;
  min-width: 210px;
  padding: 12px;
  text-align: center;
}

.doc-title {
  color: #132845;
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: 0.2px;
  line-height: 1.1;
}

.doc-subtitle {
  color: #3f4e60;
  font-size: 0.88rem;
}

.pickup-label {
  color: #4d5d6f;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.7px;
}

.folio-label {
  color: #122745;
  font-size: 1.5rem;
  font-weight: 900;
  line-height: 1;
}

.folio-label span {
  color: #122745;
}

.qr-placeholder {
  align-items: center;
  border: 1px dashed #8d9aae;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  min-height: 92px;
}

.warning-banner {
  align-items: center;
  background: #eef6ff;
  border: 1px solid #cde2fd;
  border-left: 3px solid #1890ff;
  border-radius: 8px;
  color: #1e3554;
  display: flex;
  font-size: 0.95rem;
  line-height: 1.5;
  padding: 12px;
}

.owner-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.owner-card {
  border: 1px solid #d7dce3;
  border-radius: 8px;
  padding: 12px;
}

.owner-title {
  border-bottom: 1px solid #d7dce3;
  color: #1d3049;
  font-size: 0.95rem;
  font-weight: 800;
  letter-spacing: 0.3px;
  margin-bottom: 10px;
  padding-bottom: 8px;
}

.owner-line {
  align-items: baseline;
  color: #24384f;
  display: flex;
  font-size: 0.92rem;
  gap: 6px;
  margin-bottom: 6px;
}

.owner-line span {
  color: #5a6a7f;
  font-weight: 600;
  min-width: 80px;
}

.product-table-section {
  padding-left: 0;
}

.product-table {
  border-collapse: collapse;
  width: 100%;
}

.product-table th {
  background: #1f2e45;
  color: #fff;
  font-size: 0.83rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  padding: 10px 12px;
  text-align: left;
}

.product-table td {
  border-bottom: 1px solid #dfe5ec;
  color: #21364f;
  font-size: 0.9rem;
  padding: 10px 12px;
  vertical-align: top;
}

.product-name {
  color: #1d2f47;
  font-weight: 700;
}

.product-sku {
  color: #607086;
  font-size: 0.8rem;
}

.policy-text {
  color: #2c4159;
  font-size: 0.9rem;
  line-height: 1.55;
}

.signatures {
  display: grid;
  gap: 28px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 36px;
}

.signature-block {
  text-align: center;
}

.signature-line {
  border-bottom: 2px solid #4d5d71;
  margin-bottom: 8px;
  min-height: 34px;
}

.signature-title {
  color: #24374f;
  font-size: 0.9rem;
  font-weight: 800;
}

.signature-subtitle {
  color: #5b6a7d;
  font-size: 0.8rem;
}

.avoid-page-break {
  break-inside: avoid;
  page-break-inside: avoid;
}

@media (max-width: 960px) {
  .doc-header {
    flex-direction: column;
  }

  .header-right {
    width: 100%;
  }

  .owner-grid,
  .signatures {
    grid-template-columns: 1fr;
  }
}

@media print {
  @page {
    margin: 8mm;
    size: a4 portrait;
  }

  html,
  body {
    background: #fff !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .v-application,
  .v-application--wrap,
  .v-main,
  .v-content,
  .v-content__wrap,
  .container,
  .deferred-preview-page {
    background: transparent !important;
    margin: 0 !important;
    max-width: 100% !important;
    min-height: auto !important;
    padding: 0 !important;
    width: 100% !important;
  }

  .d-print-none {
    display: none !important;
  }

  .deferred-doc {
    border: none !important;
    box-shadow: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .doc-section,
  .owner-card,
  .warning-banner,
  .header-right,
  .product-table th,
  .product-table td {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .product-table thead {
    display: table-header-group;
  }

  .product-table tr {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .signatures {
    margin-top: 28px;
  }
}
</style>
